export default __webpack_public_path__ + "static/media/Arm Bands of the Ghost of the Veldt.fbac5db7.jpg";